module.exports = __webpack_public_path__ + "img/injection_coming_soon.93c96158.jpg";